import * as yup from 'yup';

const baseSchema = yup.object({
  orderId: yup.string().required(),
  orderNumber: yup.string().required(),
  brand: yup.mixed().oneOf(['LEBT']).required(),
  currency: yup.string().required(),
  date: yup.date(),
  customer: yup
    .object({
      name: yup.string().required(),
      email: yup.string().email().required(),
      businessName: yup.string().notRequired(),
      address: yup.string().notRequired(),
      abn: yup.string().notRequired(),
    })
    .required(),
});

export const invoiceCreateSchema = baseSchema.shape({
  invoiceNumber: yup.string().required(),
  lineItems: yup
    .array()
    .of(
      yup.object({
        description: yup.string().required(),
        bookingNumber: yup.string().required(),
        totalPrice: yup.number().required(),
        gstAmount: yup.number().required(),
      }),
    )
    .min(1)
    .required(),
  payments: yup
    .array()
    .of(
      yup.object({
        description: yup.string().required(),
        amount: yup.number().required(),
        date: yup.date().required(),
      }),
    )
    .min(1)
    .required(),
});
